<template>
    <div class="authentication">
        <Bar title="认证帮助" @goBack="goBack" />
        <div class="section">
            <h4>1.教练认证有什么好处？</h4>
            <p>认证教练和未认证教练享有权益不一样，首先，认证教练更能让学员信服，认证后会得到对应的认证标记；其次，您只有通过认证才能享有对应驾校的相应权益，比如可直接获取驾校对应班别信息来扩展自己的招生名片，后期将参与教练排名。</p>
        </div>
        <div class="section">
            <h4>2.认证需要上传什么资料？</h4>
            <p>认证时除了填写姓名和选择驾校外，还需要提供在对应驾校的工作证明、驾驶证正面以及身份证人像面。工作证明一般为工牌或者手持教练车行驶证照片，也可以下载平台的模板填写信息后加盖公章上传，请勿虚假上传，否则需要承担对应的法律责任。</p>
        </div>
        <div class="section">
            <div class="photo">
                <div class="item">
                    <img src="@/assets/vipCoach/v2/picture_gzzm01@2x.png">
                    <p>模版</p>
                    <van-button class="custom-btn" color="#00CA84" round block @click="handleJumpPage">下载模版</van-button>
                </div>
                <div class="item">
                    <img src="@/assets/vipCoach/v2/picture_gzzm02@2x.png">
                    <p>盖章后</p>
                </div>
            </div>
        </div>
        <div class="section">
            <h4>3.认证需要多长时间？</h4>
            <p>一般需要1-3个工作日完成认证审核。</p>
        </div>
        <div class="section">
            <h4>4.认证后还能修改认证信息吗？</h4>
            <p>可以修改，前往我的-教练认证或个人资料编辑页面-驾校，重新进行资料提交，提交后需要等待客服重新审核。</p>
        </div>
        <div class="section">
            <h4>5.认证时我的驾校不存在怎么办？</h4>
            <p>首先确认下是否城市选择错误导致搜索不到，确实不存在需要联系在线客服，客服确认后会进行驾校补录操作，您的反馈是我们前进的最大动力，我们将竭诚为您服务。</p>
        </div>
    </div>
</template>
<script>
import Bar from '../components/bar.vue'
import { bindAppFn } from '../../utils'
import { Button } from 'vant'
export default {
    name: 'vipCoachAuthentication',
    components: {
        Bar,
        [Button.name]: Button
    },
    data () {
        return {
        }
    },
    methods: {
        // 返回上一页
        goBack () {
            bindAppFn({
                name: 'app',
                data: {
                    method: 'exitH5'
                }
            })
        },
        // 唤起
        handleJumpPage () {
            this.$router.push({
                name: 'vipCoachAuthenticationTemplate',
                query: {
                    type: 'H5'
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
* {
    box-sizing: border-box;
}
img{
    max-width: 100%;
}
.authentication{
    padding: 10px 15px;
    min-height: 100vh;
    background-color: #F3F4FB;
    line-height: 24px;
}
.section{
    margin-bottom: 30px;
    color:#333;
    h4{
        font-size: 18px;
    }
    p{
        font-size: 15px;
    }
    .photo{
        margin:0 -15px;
        display: flex;
        align-self: stretch;
        text-align: center;
        line-height: 1;
        .item{
            padding:0 15px;
            p {
                margin-top: 10px;
            }
            .custom-btn{
                margin:10px auto 0 auto;
                padding: 0;
                width: 84px;
                height: 24px;
                font-size: 15px;
            }
        }
    }
}
</style>
